import { Tooltip } from "flowbite-react";
import { Lock, Unlock } from "lucide-react";
import { useState } from "react";

const TerminalInformationCard = ({ data, msg }) => {
	const [locked, setLocked] = useState(true);

	const InfoField = ({ label, children }) => (
		<div className="text-start">
			<p className="text-[10px] text-slate-400 sm:text-xs">{label}</p>
			<div className="mt-1 text-[10px] text-slate-100 sm:text-xs">{children}</div>
		</div>
	);

	const ConnectionStatus = ({ children }) => (
		<span
			className={`inline-block rounded-md border border-blue-gray bg-blue-gray/30 px-3 py-1 font-medium text-gray-400 text-xs ${
				children === "Online"
					? "border border-green-400 bg-green-dark text-green-400"
					: "border border-red-400 bg-red-dark text-red-400"
			}`}
		>
			{children}
		</span>
	);

	const StatusBadge = ({ children }) => (
		<span
			className={`inline-block rounded-md border border-blue-gray bg-blue-gray/30 px-3 py-1 font-medium text-gray-400 text-xs ${
				children === "Active"
					? "border border-green-400 bg-green-dark text-green-400"
					: "border border-red-400 bg-red-dark text-red-400"
			}`}
		>
			{children}
		</span>
	);

	const CreationStatus = ({ children }) => (
		<span className="inline-block rounded-md border border-blue-gray bg-blue-gray/30 px-3 py-1 font-medium text-gray-400 text-xs">
			{children}
		</span>
	);

	return (
		<div className="overflow-hidden rounded-xl bg-[#171a35] shadow-lg ring-1 ring-white/5">
			<div className="flex items-center justify-between gap-2 border-slate-700 border-b px-5 py-4">
				<h1 className="text-start font-semibold text-slate-100 text-xs tracking-wide sm:text-sm">
					Terminal Information
				</h1>
				<div className="flex gap-2">
					<Tooltip
						content="Bar"
						placement="top"
						className={"border-dark-blue bg-dark-blue text-slate-300"}
						style="light"
					>
						<span className="inline-block">
							<button
								type="button"
								onClick={() => setLocked(true)}
								className={`flex h-8 w-8 items-center justify-center rounded-lg transition-colors ${
									locked
										? "bg-red-500 text-white"
										: "bg-slate-700 text-slate-400 hover:bg-slate-600"
								}`}
								aria-label="Lock terminal"
							>
								<Lock size={16} />
							</button>
						</span>
					</Tooltip>
					<Tooltip
						content="Unbar"
						placement="top"
						className={"border-dark-blue bg-dark-blue text-slate-300"}
						style="light"
					>
						<span className="inline-block">
							<button
								type="button"
								onClick={() => setLocked(false)}
								className={`flex h-8 w-8 items-center justify-center rounded-lg transition-colors ${
									!locked ? "bg-emerald-500 text-white" : "bg-slate-700 text-slate-400"
								}`}
								aria-label="Unlock terminal"
							>
								<Unlock size={16} />
							</button>
						</span>
					</Tooltip>
				</div>
			</div>
			<div className="p-4">
				<div className="grid grid-cols-2 gap-y-4">
					<InfoField label="Link id">{data.linkId}</InfoField>
					<InfoField label="MSISDN">{data.msisdn}</InfoField>

					<InfoField label="Client">{data.client}</InfoField>
					<InfoField label="Provider">{data.provider}</InfoField>
					<InfoField label="Sim Type">{data.simType}</InfoField>

					<InfoField label="Static IP address">{data.staticIp}</InfoField>
					<InfoField label="IP address">{data.ipAddress}</InfoField>
					<InfoField label="Range">{data.range}</InfoField>

					<InfoField label="Last usage date">{data.lastUsageDate}</InfoField>
					<InfoField label="Connection status">
						<div className="flex flex-col gap-1">
							<div className="flex items-center gap-2">
								<ConnectionStatus>{data.connectionStatus}</ConnectionStatus>
								<span className="text-slate-400 text-xs">{data.connectionDate}</span>
							</div>
						</div>
					</InfoField>

					<InfoField label="Creation status">
						<CreationStatus>{data.creationStatus}</CreationStatus>
					</InfoField>
					<InfoField label="Simcard status">
						<StatusBadge>{data.simcardStatus}</StatusBadge>
					</InfoField>

					<InfoField label="Usage summary">
						<div className="grid gap-2">
							<div className="mt-1 text-[12px] text-slate-100 sm:text-xs">{data.usageSummary}</div>{" "}
							<div className="font-semibold text-[10px] text-slate-100 sm:text-xs">
								Total usage : 0.00 MB
							</div>
							<div className="font-semibold text-[10px] text-slate-100 sm:text-xs">
								Stream Usage : 00:00:00
							</div>
						</div>
					</InfoField>
				</div>
			</div>
		</div>
	);
};
export default TerminalInformationCard;
